// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import CardsPage from './components/pages/Cards'
import AuthPage from './components/pages/Auth'
import CreateStack from './components/cards/CreateStack'
import StacksPage from './components/pages/Stacks'
import StackPage from './components/pages/Stack'
import Register from './components/pages/Register'
import VueSimpleBreakpoints from 'vue-simple-breakpoints'

Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.use(VueSimpleBreakpoints)

let router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'cards', path: '/cards', component: CardsPage },
    { name: 'auth', path: '/auth', component: AuthPage },
    { name: 'create stack', path: '/stacks/create', component: CreateStack },
    { name: 'stacks', path: '/', component: StacksPage },
    { name: 'stack', path: '/stack/:slug', component: StackPage },
    { name: 'register', path: '/register', component: Register}
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router: router
})


// WEBPACK FOOTER //
// ./src/main.js